import http from './http';

/**
 * 获取用户登录后的数据
 */
function  postUserPoints (getEmail) {
	return new Promise((resolve, reject) => {
		http('post', '/get-share', {
			customerEmail: getEmail
		}).then((res) => {
			resolve(res);
		})
		.catch((error) => {
			console.log("网络异常~",error);
			reject(error)
		})
	})
}
/**
 * 积分兑换
 */
function convertPoints (getEmail,points) {
	return new Promise((resolve, reject) => {
		http('post', '/convert-points',{
			customerEmail: getEmail,
			convertPoints: points
		}).then((res)=> {
			resolve(res)
		}).catch((err)=>{
			console.log(err);
			reject(err)
		})
	})
}

/**
 * 查询兑换列表
 */
function getCodeLists (getEmail) {
	return new Promise((resolve, reject) => {
		http('post', '/get-code-list',{
			customerEmail: getEmail
		}).then((res)=> {
			resolve(res)
		}).catch((err)=>{
			console.log(err);
			reject(err)
		})
	})
}

/**
 * 查询code详情
 */
function getCodeDetail (getEmail,codeId) {
	return new Promise((resolve, reject) => {
		http('post', '/get-code-detail',{
			customerEmail: getEmail,
			codeId: codeId
		}).then((res)=> {
			resolve(res);
		}).catch((err)=>{
			console.log(err);
			reject(err)
		})
	})
}

/**
 * 查询积分记录列表
 */ 

function getPointRecord (getEmail) {
	return new Promise((resolve, reject) => {
		http('post', '/get-points-record',{
			customerEmail: getEmail,
		}).then((res)=> {
			resolve(res)
		}).catch((err)=>{
			console.log(err);
			reject(err)
		})
	})
}

/**
 * Follow接口
 */
function getFollow (getEmail, followFlag) {
	return new Promise((resolve, reject) => {
		http('post', '/follow-homepage', {
			customerEmail: getEmail,
			followFlag: followFlag
		}).then((res)=>{
			resolve(res)
		}).catch((err)=>{
			console.log(err);
			reject(err)
		})
	})
}

/**
 * 查看用户下单获取的code
 */ 
function getRefCompleted(getEmail) {
	return new Promise((resolve, reject) => {
		http('post', '/get-ref-completed', {
			customerEmail: getEmail
		}).then((res)=>{
			resolve(res)
		}).catch((err)=>{
			console.log(err);
			reject(err)
		})
	})
}

/**
 * 发送邮件
 */
 
 function sendRefEmail(email) {
	 return new Promise((resolve, reject)=> {
		 http('post', '/send-ref-email', {
			 customerEmail: email
		 }).then((res) => {
			resolve(res);
		 }).catch((err) => {
			 console.log(err);
			 reject(err);
		 })
	 })
 }

/**
 * 埋点
 */

function trackSharePop(email,visitorId,position) {
	return new Promise((resolve, reject) => {
		http('get', '/tracking-share-pop.gif', {
			visitorId: visitorId,
			email:email,
			position:position
		}).then((res)=>{
			resolve(res)
		}).catch((err)=>{
			console.log(err);
			reject(err)
		})
	})
}

export {
	postUserPoints,
	convertPoints,
	getCodeLists,
	getCodeDetail,
	getPointRecord,
	getFollow,
	getRefCompleted,
	sendRefEmail,	
	trackSharePop,
}